import styled from "styled-components";
import NavBar from "../../components/NavBar";
import Switch from "../../components/Switch";
import WalletTab from "./components/WalletTab";
import ProfitTab from "./components/ProfitTab";
import LotteryTab from "./components/LotteryTab";
import "./style.css";
import { useState } from "react";
import { useIntl } from "react-intl";
import useLayout from "../../hooks/Layout/useLayout";

export default function Account() {
  const {navigateTo} = useLayout()
  const intl = useIntl();
  const tabList = [
    {
      id: 1,
      name: intl.formatMessage({
        id: "pages.account.wallet",
        defaultMessage: "錢包",
      }),
    },
    {
      id: 2,
      name: intl.formatMessage({
        id: "pages.account.profit",
        defaultMessage: "收益",
      }),
    },
    {
      id: 3,
      name: intl.formatMessage({
        id: "pages.account.lottery",
        defaultMessage: "抽獎",
      }),
    },
  ];

  
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <>
      <NavBar
        title={intl.formatMessage({
          id: "pages.account.title",
          defaultMessage: "账户",
        })}
        Right={() => (
          <>
            <img
              onClick={() => {
                navigateTo("/user",'/account');
              }}
              src="/image/setting.png"
              alt="setting"
            />
          </>
        )}
       
      />
      <Wrapper>
        <Switch
          list={tabList}
          activeIndex={activeTabIndex}
          onChange={setActiveTabIndex}
        />
        {activeTabIndex === 0 ? (
          <WalletTab />
        ) : activeTabIndex === 1 ? (
          <ProfitTab />
        ) : (
          <LotteryTab />
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  padding: 0 1.3rem;
`;
